// Simple in-memory store for storeIds shared between dataProvider and filters
let storeIds: string[] = [];
const listeners = new Set<() => void>();

export const setStoreIds = (ids: string[]) => {
  storeIds = ids || [];
  listeners.forEach((listener) => listener());
};

export const getStoreIds = () => storeIds;

export const subscribeStoreIds = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
